'use client';

import { useEffect, useRef, useState } from 'react';
import { ArrowRightIcon, ArrowLeftIcon } from '@kohler-dsm-library/kohler-icons';
import FeatureCard from './FeatureCard';

const FeatureCarousel = ({ cards, activeId, hoveredId, onSelect, onHover }) => {
  const cardRefs = useRef({});
  const containerRef = useRef(null);
  const isFirstRender = useRef(true);

  const [canScrollLeft, setCanScrollLeft] = useState(false);
  const [canScrollRight, setCanScrollRight] = useState(true);

  useEffect(() => {
    if (isFirstRender.current) {
      isFirstRender.current = false;
      return;
    }

    const activeCard = cardRefs.current[activeId];

    if (activeCard) {
      activeCard.scrollIntoView({
        behavior: 'smooth',
        inline: 'center',
        block: 'nearest',
      });
    }
  }, [activeId]);

  const updateScrollState = () => {
    const el = containerRef.current;
    if (!el) return;

    setCanScrollLeft(el.scrollLeft > 10);
    setCanScrollRight(el.scrollLeft + el.clientWidth < el.scrollWidth - 10);
  };

  useEffect(() => {
    updateScrollState();
  }, [cards]);

  const scrollRight = () => {
    const el = containerRef.current;
    if (!el) return;

    el.scrollBy({
      left: el.clientWidth,
      behavior: 'smooth',
    });

    setTimeout(updateScrollState, 400);
  };

  const scrollLeft = () => {
    const el = containerRef.current;
    if (!el) return;

    el.scrollBy({
      left: -el.clientWidth,
      behavior: 'smooth',
    });

    setTimeout(updateScrollState, 400);
  };

  return (
    <>
      {/* LEFT ARROW */}
      {canScrollLeft && (
        <button type="button" className="carousel-arrow left" onClick={scrollLeft}>
          <ArrowLeftIcon />
        </button>
      )}

      {/* CAROUSEL */}
      <div className="fpc-carousel" ref={containerRef} onScroll={updateScrollState}>
        {cards.map((card) => (
          <div
            key={card.id}
            ref={(el) => (cardRefs.current[card.id] = el)}
            className={`card ${activeId === card.id || hoveredId === card.id ? 'active' : ''}`}
            onMouseEnter={() => onHover(card.id)}
            onMouseLeave={() => onHover(null)}
          >
            <FeatureCard
              card={card}
              isActive={activeId === card.id}
              isHovered={hoveredId === card.id}
              onClick={() => onSelect(card.id)}
              onHover={onHover}
            />
          </div>
        ))}
      </div>

      {/* RIGHT ARROW */}
      {canScrollRight && (
        <button type="button" className="carousel-arrow right" onClick={scrollRight}>
          <ArrowRightIcon />
        </button>
      )}
    </>
  );
};

export default FeatureCarousel;
